import { render, staticRenderFns } from "./RequestFeature.ts.vue?vue&type=template&id=f5a62990"
import script from "./RequestFeature.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestFeature.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./RequestFeature.ts.vue?vue&type=style&index=0&id=f5a62990&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports